"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminResultsTab = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const PortalTypes_1 = require("@common/types/PortalTypes");
const moment_1 = __importDefault(require("moment"));
const ClassMode_1 = require("../util/ClassMode");
const SortableTable_1 = require("../util/SortableTable");
const UI_1 = require("../util/UI");
const AdminDeliverablesTab_1 = require("./AdminDeliverablesTab");
const AdminPage_1 = require("./AdminPage");
const AdminView_1 = require("./AdminView");
const SEARCH_BOX_ATTRS = {
    spellcheck: "false",
    autocomplete: "off",
    autocorrect: "off",
    autocapitalize: "off",
    "data-lpignore": "true",
    "data-1p-ignore": "true",
};
class AdminResultsTab extends AdminPage_1.AdminPage {
    constructor(remote) {
        super(remote);
        this.delivValue = null;
        this.repoValue = null;
    }
    static selectedView() {
        const select = document.querySelector("#resultsViewSelect");
        if (select === null) {
            return "all";
        }
        return PortalTypes_1.PERSON_VIEWS.indexOf(select.value) >= 0 ? select.value : "all";
    }
    wireViewSelector() {
        const select = document.querySelector("#resultsViewSelect");
        if (select === null) {
            return;
        }
        select.onchange = () => {
            this.init({}).catch((err) => {
                Log_1.default.error("AdminResultsTab::wireViewSelector(..) - ERROR: " + err.message);
            });
        };
    }
    wireDelivSelector(delivs, repos) {
        const select = document.querySelector("#resultsDelivSelect");
        if (select === null) {
            return;
        }
        select.onchange = () => {
            this.refreshResults(delivs, repos);
        };
    }
    refreshResults(delivs, repos) {
        UI_1.UI.showModal("Retrieving results.");
        this.performQueries()
            .then((newResults) => {
            this.render(delivs, repos, newResults);
            UI_1.UI.hideModal();
        })
            .catch((err) => {
            UI_1.UI.hideModal();
            UI_1.UI.showError(err);
        });
    }
    buildRepoOptions(repos) {
        const names = [];
        for (const repo of repos) {
            names.push(repo.id);
        }
        return names;
    }
    personFilter() {
        return null;
    }
    init(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            Log_1.default.info("AdminResultsTab::init(..) - start");
            const that = this;
            document.getElementById("resultsListTable").innerHTML = "";
            UI_1.UI.showModal("Retrieving results.");
            const course = yield AdminView_1.AdminView.getCourse(this.remote);
            if (this.delivValue === null) {
                this.delivValue = (_a = course.defaultDeliverableId) !== null && _a !== void 0 ? _a : "any";
                UI_1.UI.setDropdownOptions("resultsDelivSelect", [this.delivValue], this.delivValue);
            }
            const delivs = yield AdminDeliverablesTab_1.AdminDeliverablesTab.getDeliverables(this.remote);
            const repos = yield AdminResultsTab.getRepositories(this.remote);
            const results = yield this.performQueries();
            UI_1.UI.hideModal();
            this.wireViewSelector();
            this.wireDelivSelector(delivs, repos);
            const fab = document.querySelector("#resultsUpdateButton");
            fab.onclick = function (_evt) {
                Log_1.default.info("AdminResultsTab::init(..)::updateButton::onClick");
                that.refreshResults(delivs, repos);
            };
            this.render(delivs, repos, results);
        });
    }
    performQueries() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminResultsTab::performQueries(..) - start");
            const start = Date.now();
            let deliv = UI_1.UI.getDropdownValue("resultsDelivSelect");
            if (deliv === "-Any-") {
                deliv = "any";
            }
            let repo = UI_1.UI.getDropdownValue("resultsRepoSelect");
            if (repo === "-Any-") {
                repo = "any";
            }
            this.delivValue = deliv;
            this.repoValue = repo;
            const classMode = ClassMode_1.ClassMode.isOn();
            const person = classMode === true ? null : this.personFilter();
            const repoFilter = classMode === true || person !== null ? "any" : this.repoValue;
            const values = yield AdminResultsTab.getResults(this.remote, this.delivValue, repoFilter, AdminResultsTab.selectedView(), person);
            Log_1.default.info("AdminResultsTab::performQueries(..) - done; # values: " + values.length + "; took: " + UI_1.UI.took(start));
            return values;
        });
    }
    buildHeaders() {
        return [
            {
                id: "timstamp",
                text: "Timestamp",
                sortable: true,
                defaultSort: true,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "?",
                text: "?",
                sortable: false,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "repoId",
                text: "Repository",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: left;",
            },
            {
                id: "delivId",
                text: "Deliv",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "score",
                text: "Score %",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "scoreTest",
                text: "Correctness %",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "scoreCover",
                text: "Cover %",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "state",
                text: "State",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
        ];
    }
    static percentCell(value) {
        const SPACER = "&#8199;";
        if (typeof value !== "number") {
            return SPACER + SPACER + "N/A";
        }
        if (value === 100) {
            return "100.00";
        }
        return (value < 10 ? SPACER + SPACER : SPACER) + value.toFixed(2);
    }
    adminLink(url) {
        return url;
    }
    decorateRow(row, result) {
        void result;
        return row;
    }
    renderResults(results) {
        Log_1.default.trace("AdminResultsTab::renderResults: " + results.length);
        const headers = this.buildHeaders();
        const st = new SortableTable_1.SortableTable(headers, "#resultsListTable");
        st.hiddenColumns = ClassMode_1.ClassMode.isOn() === true ? [ClassMode_1.ClassMode.SUBJECT_COLUMN] : [];
        for (const result of results) {
            const ts = result.timestamp;
            const date = new Date(ts);
            const mom = (0, moment_1.default)(date);
            const tsString = mom.format("MM/DD[@]HH:mm");
            const stdioViewerURL = "/stdio.html?delivId=" + result.delivId + "&repoId=" + result.repoId + "&sha=" + result.commitSHA;
            const commitURL = this.adminLink(result.commitURL);
            const repoURL = this.adminLink(result.repoURL);
            const score = AdminResultsTab.percentCell(result.scoreOverall);
            const row = [
                { value: ts, html: "<a class='selectable' href='" + commitURL + "'>" + tsString + "</a>" },
                {
                    value: "",
                    html: "<a style='cursor: pointer; cursor: hand;' target='_blank' href='" +
                        stdioViewerURL +
                        "'><ons-icon icon='md-info-outline'</ons-icon></a>",
                },
                {
                    value: result.repoId,
                    html: "<a class='selectable' href='" + repoURL + "'>" + result.repoId + "</a>",
                },
                { value: result.delivId, html: result.delivId },
                { value: result.scoreOverall, html: score },
                { value: result.scoreTests, html: AdminResultsTab.percentCell(result.scoreTests) },
                { value: result.scoreCover, html: AdminResultsTab.percentCell(result.scoreCover) },
                { value: result.state, html: result.state },
            ];
            st.addRow(this.decorateRow(row, result));
        }
        st.generate();
        if (st.numRows() > 0) {
            UI_1.UI.showSection("resultsListTable");
            UI_1.UI.hideSection("resultsListTableNone");
        }
        else {
            UI_1.UI.showSection("resultsListTable");
            UI_1.UI.hideSection("resultsListTableNone");
        }
    }
    render(delivs, repos, results) {
        Log_1.default.trace("AdminResultsTab::render(..) - start");
        const that = this;
        let delivNames = [];
        for (const deliv of delivs) {
            delivNames.push(deliv.id);
        }
        delivNames = delivNames.sort();
        delivNames.unshift("-Any-");
        UI_1.UI.setDropdownOptions("resultsDelivSelect", delivNames, this.delivValue);
        let repoNames = this.buildRepoOptions(repos);
        repoNames = repoNames.sort();
        repoNames.unshift("-Any-");
        UI_1.UI.setDropdownOptions("resultsRepoSelect", repoNames, this.repoValue);
        this.renderResults(results);
        try {
            new TomSelect("#resultsRepoSelect", {
                maxOptions: null,
                maxItems: 1,
                closeAfterSelect: true,
                onInitialize: function () {
                    for (const [attr, value] of Object.entries(SEARCH_BOX_ATTRS)) {
                        this.control_input.setAttribute(attr, value);
                    }
                },
                onDropdownOpen: function () {
                    Log_1.default.trace("AdminResultsTab::render(..)::repoSelect - Clearing input: " + this);
                    this.setValue("");
                },
                onDropdownClose: function () {
                    Log_1.default.trace("AdminResultsTab::render(..)::repoSelect - Performing search: " + this);
                    Log_1.default.trace("AdminResultsTab::render(..)::repoSelect - Search value: " + this.getValue());
                    if (this.getValue() === "") {
                        this.setValue("-Any-");
                    }
                    void that.init({}).then().catch();
                    this.blur();
                },
            });
        }
        catch (err) {
            Log_1.default.trace("AdminResultsTab::render(..) - updating select; MSG: " + err.message);
        }
        ClassMode_1.ClassMode.showFilter("resultsRepoLabel", "resultsRepoSelect", ClassMode_1.ClassMode.isOn() === false);
    }
    static getResults(remote_1, delivId_1, repoId_1) {
        return __awaiter(this, arguments, void 0, function* (remote, delivId, repoId, view = "all", person = null) {
            Log_1.default.info("AdminResultsTab::getResults( .. ) - start");
            const start = Date.now();
            let url = remote + "/portal/admin/results/" + delivId + "/" + repoId + "/" + view;
            if (person !== null && person.length > 0) {
                url += "?person=" + encodeURIComponent(person);
            }
            const options = AdminView_1.AdminView.getOptions();
            const response = yield fetch(url, options);
            if (response.status === 200) {
                Log_1.default.trace("AdminResultsTab::getResults(..) - 200 received");
                const json = yield response.json();
                if (typeof json.success !== "undefined" && Array.isArray(json.success)) {
                    Log_1.default.trace("AdminResultsTab::getResults(..)  - worked; # rows: " + json.success.length + "; took: " + UI_1.UI.took(start));
                    return json.success;
                }
                else {
                    Log_1.default.trace("AdminResultsTab::getResults(..)  - ERROR: " + json.failure.message);
                    AdminView_1.AdminView.showError(json.failure);
                }
            }
            else {
                Log_1.default.trace("AdminResultsTab::getResults(..)  - !200 received: " + response.status);
                const text = yield response.text();
                AdminView_1.AdminView.showError(text);
            }
            return [];
        });
    }
    static getRepositories(remote) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminResultsTab::getRepositories( .. ) - start");
            try {
                const start = Date.now();
                const url = remote + "/portal/admin/repositories";
                const options = AdminView_1.AdminView.getOptions();
                const response = yield fetch(url, options);
                if (response.status === 200) {
                    Log_1.default.trace("AdminResultsTab::getRepositories(..) - 200 received");
                    const json = yield response.json();
                    if (typeof json.success !== "undefined" && Array.isArray(json.success)) {
                        Log_1.default.trace("AdminResultsTab::getRepositories(..)  - worked; # repos: " + json.success.length + "; took: " + UI_1.UI.took(start));
                        return json.success;
                    }
                    else {
                        Log_1.default.trace("AdminResultsTab::getRepositories(..)  - ERROR: " + json.failure.message);
                        AdminView_1.AdminView.showError(json.failure);
                    }
                }
                else {
                    Log_1.default.trace("AdminResultsTab::getRepositories(..)  - !200 received: " + response.status);
                    const text = yield response.text();
                    AdminView_1.AdminView.showError(text);
                }
            }
            catch (err) {
                AdminView_1.AdminView.showError("Getting results failed: " + err.message);
            }
            return [];
        });
    }
}
exports.AdminResultsTab = AdminResultsTab;
